import React from 'react';
import { Link } from 'react-router-dom';
import truncate from 'lodash/truncate';

const ListArticles = ({ rows }) => (
  <div className="container-fluid border-top my-4">
    {rows.map((r) => {
      const href = `/articles/${r._id}`;

      return (
        <div
          key={r._id}
          className="row border-bottom py-4 py-md-3 align-items-center"
        >
          <div className="col">
            <div className="row align-items-center">
              <div className="col-12 col-lg">
                <h4>
                  {r.title}
                </h4>
                <p className="mb-2">
                  {truncate(r.contentText, {
                    length: 60,
                    omission: '……',
                  })}
                </p>
              </div>
              <div className="col-auto">
                <Link
                  to={href}
                  className="btn btn-primary px-4 py-2"
                >
                  <span className="mr-3">
                    閱讀文章
                  </span>
                  &nbsp;
                  <img
                    src='assets/img/long-arrow-right.svg'
                    style={{ width: '38px', height: '9px' }}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      );
    })}
  </div>
);

export default ListArticles;
